import { getUnixTime } from 'date-fns/getUnixTime'

import { AnalyticsApi } from '../../core/api'
import { BasicAnalyticsEvent, AnalyticsSession, BasicAnalyticsPageview } from '../../core'

export const analyticsSession = async (
  endpoint: string,
  token: string,
  version = '1.0.0',
  featureName = 'Experiences',
) => {
  const analyticsApi = new AnalyticsApi(endpoint, token)
  const { analytics_session } = (await analyticsApi.initializeAnalyticsSession(
    version,
    featureName,
  )) as {
    analytics_session: AnalyticsSession
  }

  const host = window.location.hostname

  return {
    sendAnalyticEvent: async (event: BasicAnalyticsEvent) => {
      return await analyticsApi.sendAnalyticEvent({
        analytics_event: {
          ...event,
          app_version: 'widgets-v2',
          created_at: getUnixTime(new Date()).toString(),
          host,
          name: event?.label || '',
          session_id: analytics_session.guid,
          user_agent: navigator.userAgent || '',
          version: 2,
        },
      })
    },
    sendAnalyticsPageview: async (pageview: BasicAnalyticsPageview) => {
      return await analyticsApi.sendAnalyticsPageview({
        analytics_pageview: {
          ...pageview,
          app_version: 'widgets-v2',
          created_at: getUnixTime(new Date()).toString(),
          host,
          name: pageview.name,
          session_id: analytics_session.guid,
          user_agent: navigator.userAgent || '',
        },
      })
    },
  }
}
